import * as z from "zod/v4";

const DisplayMessageItem_ = z.object({
  type: z.literal("message"),
  role: z.enum(["user", "assistant"]),
  content: z.string(),
});

const DisplayToolCallStatusItem_ = z.object({
  type: z.literal("tool-call-status"),
  toolCallId: z.string(),
  toolName: z.string(),
  input: z.unknown(),
  isComplete: z.literal(true),
});

const DisplayAskUserQuestionItem_ = z.object({
  type: z.literal("ask-user-question"),
  toolCallId: z.string(),
  input: z.unknown(),
});

export const AeoAssistantDisplayItemSchema = z.discriminatedUnion("type", [
  DisplayMessageItem_,
  DisplayToolCallStatusItem_,
  DisplayAskUserQuestionItem_,
]);
export type AeoAssistantDisplayItem = z.infer<
  typeof AeoAssistantDisplayItemSchema
>;

const PendingConfirmationSchema_ = z.object({
  toolCallId: z.string(),
  toolName: z.string(),
  confirmationData: z.unknown(),
  confirmationPrompt: z.string(),
});
export type PendingConfirmation = z.infer<typeof PendingConfirmationSchema_>;

export const getAeoAssistantThreadMessages = {
  name: "getAeoAssistantThreadMessages" as const,
  input: z.object({ threadId: z.string() }),
  output: z.object({
    threadId: z.string(),
    items: z.array(AeoAssistantDisplayItemSchema),
    pendingConfirmations: z.array(PendingConfirmationSchema_),
  }),
};
